(function () {
  'use strict';

  function money(cents, moneyFormat) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (e) {}
    var amount = (Number(cents) / 100).toFixed(2).replace('.', ',');
    return amount + ' TL';
  }

  function initHero(root) {
    if (!root || root.dataset.npReady === '1') return;
    root.dataset.npReady = '1';

    var moneyFormat = root.dataset.moneyFormat || '{{amount}} TL';
    var variants;
    try {
      variants = JSON.parse(root.dataset.variantsJson || '[]');
    } catch (e) {
      variants = [];
    }

    var form = root.querySelector('form.np-hero__form') || root.querySelector('[data-np-form]');
    var idInput = root.querySelector('[data-np-variant-id]');
    var priceEl = root.querySelector('[data-np-price]');
    var compareEl = root.querySelector('[data-np-compare]');
    var stickyPrice = document.querySelector('[data-np-sticky-price]');
    var qtyInput = root.querySelector('[data-np-qty]');
    var atcBtn = root.querySelector('[data-np-atc]');
    var buyBtn = root.querySelector('[data-np-buy]');
    var stickyAtc = document.querySelector('[data-np-sticky-atc]');
    var stickyBuy = document.querySelector('[data-np-sticky-buy]');
    var errorEl = root.querySelector('[data-np-error]');
    var unitEl = root.querySelector('[data-np-unit]');
    var shippingTextEl = root.querySelector('[data-np-shipping-text]');
    var variantBtns = root.querySelectorAll('[data-np-variant]');
    var mainImg = root.querySelector('[data-np-main-image]') || root.querySelector('.np-hero__main img');
    var thumbs = root.querySelectorAll('[data-np-thumb]');
    var observeTarget = root.querySelector('[data-np-atc]') || root.querySelector('[data-np-observe]');
    var sticky = document.querySelector('[data-np-sticky]');

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.classList.toggle('is-visible', !!msg);
    }

    function publishCustomEvent(name, payload) {
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, payload);
        }
      } catch (e) {}
    }

    function setMainImage(src, alt) {
      if (!mainImg || !src) return;
      var widths = [360, 540, 720, 960, 1200, 1400];
      var imageUrlForWidth = function (width) {
        if (/([?&])width=\d+/.test(src)) {
          return src.replace(/([?&])width=\d+/, '$1width=' + width);
        }
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      };
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = imageUrlForWidth(960);
      mainImg.srcset = widths
        .map(function (width) {
          return imageUrlForWidth(width) + ' ' + width + 'w';
        })
        .join(', ');
      mainImg.sizes = '(max-width: 899px) calc(100vw - 2rem), (max-width: 1200px) 50vw, 560px';
      if (alt) mainImg.alt = alt;
    }

    function currentVariant() {
      var id = idInput ? String(idInput.value) : '';
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return variants[0] || null;
    }

    function syncShipping(v) {
      if (!shippingTextEl || !v) return;
      var freeText = shippingTextEl.getAttribute('data-shipping-free') || 'Ücretsiz kargo';
      var defaultText =
        shippingTextEl.getAttribute('data-shipping-default') ||
        'Türkiye geneli kargo: 250 TL (ödeme adımında eklenir).';
      var threshold = Number(shippingTextEl.getAttribute('data-shipping-free-threshold')) || 400000;
      shippingTextEl.textContent = Number(v.price) >= threshold ? freeText : defaultText;
    }

    function syncUnit(v) {
      if (!unitEl || !v) return;
      var units = Number(v.units) || 1;
      if (units <= 1) {
        unitEl.textContent = '';
        unitEl.hidden = true;
        return;
      }
      var perUnit = Math.round(Number(v.price) / units);
      var single = variants.find(function (item) {
        return Number(item.units) === 1;
      });
      var singlePrice = single ? Number(single.price) : 0;
      var savePct =
        singlePrice > 0 ? Math.max(0, Math.round((1 - perUnit / singlePrice) * 100)) : 0;
      unitEl.hidden = false;
      unitEl.textContent =
        'Adet başına ' +
        money(perUnit, moneyFormat) +
        (savePct > 0 ? ' · Tekli pakete göre %' + savePct + ' avantaj' : '');
    }

    function syncPrice(v) {
      if (!v) return;
      var formatted = money(v.price, moneyFormat);
      if (priceEl) priceEl.textContent = formatted;
      if (stickyPrice) stickyPrice.textContent = formatted;
      syncUnit(v);
      syncShipping(v);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.hidden = false;
          compareEl.textContent = money(v.compare_at_price, moneyFormat);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      var available = !!v.available;
      if (atcBtn) atcBtn.disabled = !available;
      if (buyBtn) buyBtn.disabled = !available;
      if (stickyAtc) stickyAtc.disabled = !available;
      if (stickyBuy) stickyBuy.disabled = !available;
      if (atcBtn) {
        atcBtn.querySelector('[data-np-atc-label]').textContent = available
          ? root.dataset.atcLabel || 'Sepete Ekle'
          : root.dataset.soldOutLabel || 'Tükendi';
      }
      if (stickyAtc) {
        stickyAtc.textContent = available
          ? root.dataset.atcLabel || 'Sepete Ekle'
          : root.dataset.soldOutLabel || 'Tükendi';
      }
    }

    function selectVariant(id) {
      if (!idInput) return;
      idInput.value = id;
      variantBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(btn.dataset.npVariant) === String(id) ? 'true' : 'false');
      });
      var v = currentVariant();
      syncPrice(v);
      if (v && v.featured_image) {
        setMainImage(v.featured_image, v.featured_image_alt || '');
      }
      if (v) {
        publishCustomEvent('nogag_variant_selected', {
          product_id: String(root.dataset.productId || ''),
          variant_id: String(v.id),
          variant_title: String(v.title || ''),
          units: Number(v.units) || 1,
        });
      }
      showError('');
    }

    variantBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectVariant(btn.dataset.npVariant);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        var src = thumb.getAttribute('data-src') || thumb.dataset.src;
        var alt = thumb.getAttribute('data-alt') || thumb.dataset.alt || '';
        setMainImage(src, alt);
        thumbs.forEach(function (t) {
          t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
        });
      });
    });

    root.querySelectorAll('[data-np-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = String(n);
      });
    });
    root.querySelectorAll('[data-np-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = String(n);
      });
    });

    function setLoading(on) {
      var available = !!(currentVariant() && currentVariant().available);
      root.classList.toggle('is-loading', on);
      root.setAttribute('aria-busy', on ? 'true' : 'false');
      if (atcBtn) atcBtn.disabled = on || !available;
      if (buyBtn) buyBtn.disabled = on || !available;
      if (stickyAtc) stickyAtc.disabled = on || !available;
      if (stickyBuy) stickyBuy.disabled = on || !available;
    }

    function createCartLinesUpdateEvent(variantId, quantity) {
      var CartLinesUpdateEvent = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
      if (!CartLinesUpdateEvent) return null;
      var deferred = CartLinesUpdateEvent.createPromise();
      root.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: quantity }],
          promise: deferred.promise,
        })
      );
      return deferred;
    }

    function resolveCartLinesUpdate(deferred) {
      if (!deferred) return Promise.resolve();
      var CartLinesUpdateEvent = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
      if (!CartLinesUpdateEvent) return Promise.resolve();
      var cartUrl = window.Shopify?.routes?.root
        ? window.Shopify.routes.root + 'cart.js'
        : '/cart.js';
      return fetch(cartUrl, { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Sepet doğrulanamadı');
          return res.json();
        })
        .then(function (cart) {
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
        })
        .catch(function (error) {
          deferred.reject(error);
        });
    }

    function addToCart(goCheckout) {
      var v = currentVariant();
      if (!v || !v.available) {
        showError(root.dataset.soldOutLabel || 'Tükendi');
        return;
      }
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var linesUpdateDeferred = createCartLinesUpdateEvent(v.id, qty);
      setLoading(true);
      showError('');
      publishCustomEvent('nogag_cta_clicked', {
        action: goCheckout ? 'buy_now' : 'add_to_cart',
        product_id: String(root.dataset.productId || ''),
        variant_id: String(v.id),
        quantity: qty,
      });
      fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(v.id), quantity: qty }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Sepete eklenemedi');
            return data;
          });
        })
        .then(function () {
          return resolveCartLinesUpdate(linesUpdateDeferred).then(function () {
            if (goCheckout) {
              window.location.href = window.Shopify?.routes?.root
                ? window.Shopify.routes.root + 'checkout'
                : '/checkout';
              return;
            }
            window.location.href = window.Shopify?.routes?.root
              ? window.Shopify.routes.root + 'cart'
              : '/cart';
          });
        })
        .catch(function (err) {
          if (linesUpdateDeferred) linesUpdateDeferred.reject(err);
          showError(err.message || 'Bir hata oluştu');
          setLoading(false);
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(false);
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        addToCart(true);
      });
    }
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        addToCart(false);
      });
    }
    if (stickyBuy) {
      stickyBuy.addEventListener('click', function () {
        addToCart(true);
      });
    }

    syncPrice(currentVariant());

    if (sticky && observeTarget && 'IntersectionObserver' in window) {
      function syncStickyVisibility(shouldShow) {
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        sticky.inert = !shouldShow;
        if (!shouldShow && sticky.contains(document.activeElement) && atcBtn) {
          atcBtn.focus({ preventScroll: true });
        }
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var hasScrolledEnough = window.scrollY > 220;
            var shouldShow = !entry.isIntersecting && hasScrolledEnough;
            syncStickyVisibility(shouldShow);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -10% 0px' }
      );
      io.observe(observeTarget);
    }
  }

  function initHowto(root) {
    if (!root) return;
    var steps = root.querySelectorAll('[data-np-howto-step]');
    if (!steps.length) return;
    if (!('IntersectionObserver' in window)) {
      steps.forEach(function (s) {
        s.classList.add('is-in');
      });
      return;
    }
    root.setAttribute('data-np-animate', '');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = Number(entry.target.dataset.delay || 0);
            setTimeout(function () {
              entry.target.classList.add('is-in');
            }, delay);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    steps.forEach(function (step, i) {
      step.dataset.delay = String(i * 120);
      io.observe(step);
    });
  }

  function initFaq(root) {
    if (!root) return;
    root.querySelectorAll('[data-np-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-np-faq-q]');
      var panel = item.querySelector('[data-np-faq-a]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-np-hero]').forEach(initHero);
    document.querySelectorAll('[data-np-howto]').forEach(initHowto);
    document.querySelectorAll('[data-np-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
